import React from "react";

import { PermissionGuard } from "components/wrappers/PermissionGuard";
import DashboardManagement from "./components/DashboardManagement";

const DashboardManagementAuth: React.FC = () => {
  return (
    <PermissionGuard permissions="CUSTOMIZE_DATA_SERVICE_DASHBOARD">
      <DashboardManagement />
    </PermissionGuard>
  );
};

export default DashboardManagementAuth;
